<ng-container *ngIf="errorGroup">
  <ul class="plyca-error-list">
    <li class="plyca-formErrorGroup ">
      <a (click)="this.formService.navigateToGroup(errorGroup.fieldGroup)"> {{
        this.getGroupDescription(errorGroup.fieldGroup) }}</a>
      <plyca-error-counter [errorGroup]="errorGroup" [displayShowButton]="true" (showEvent)="
          errorGroup.numberOfErrors() > 0
            ? (this.showErrors = !this.showErrors)
            : undefined
        ">
      </plyca-error-counter>
    </li>
    <li *ngIf="errorGroup.numberOfErrors() > 0" [ngClass]="this.showErrors ? 'd-none' : undefined">
      <ul>
        <li *ngFor="let field of errorGroup.fields; let i = index">
          <a (click)="this.formService.navigateToField(field._field)">
            <strong class="m-t-md">
              {{ this.getFieldDescription(field) }}
              <!-- <ng-container *ngIf="field.descriptionKeyExpression">
                {{ (this.formService.evalExpression(field.descriptionKeyExpression, [field.model], field)) | translate}}
              </ng-container>
              <ng-container *ngIf="!field.descriptionKeyExpression">
                {{ field.descriptionKey | translate }}
              </ng-container> -->
            </strong></a>
          <i *ngIf="helpEntriesAvailable(field)" class="fa fa-info-circle text text-info m-l-sm" style="cursor:pointer;"
            aria-hidden="true" (click)="showHelpEntries (field)"></i>
          <ng-container *ngTemplateOutlet="
              printError;
              context: { errorsToPrint: field.errors }
            "></ng-container>
        </li>
      </ul>
    </li>
  </ul>
</ng-container>
<ng-container *ngIf="unmapedErrors">
  <ul class="plyca-error-list">
    <li class="plyca-formErrorGroup ">
      <a>{{ "Forms.unmappedErrorGroup" | translate }}</a>
    </li>
    <li>
      <ng-container *ngTemplateOutlet="
          printError;
          context: { errorsToPrint: unmapedErrors }
        "></ng-container>
    </li>
  </ul>
</ng-container>
<ng-template #printError let-errors="errorsToPrint">
  <ng-container *ngIf="errors">
    <ul class="plyca-error-list">
      <li *ngFor="let error of errors" class="m-t-xs m-l-xs">
        <div class="text-doc text-spacing">
          <i *ngIf="error.type === 'FATAL'" class="fas fa-lg fa-exclamation-circle text-danger" aria-hidden="true"></i>
          <i *ngIf="error.type === 'ERROR'" class="fas fa-lg fa-exclamation-triangle text-danger"
            aria-hidden="true"></i>
          <i *ngIf="error.type === 'WARNING'" class="fas fa-lg fa-exclamation-triangle text-warning"
            aria-hidden="true"></i>
          <div class="d-inline ml-1 textoerror" [innerHTML]="error.message | translate"
            [ngClass]="{'text-danger': error.type === 'FATAL'}"></div>
        </div>
      </li>
    </ul>
  </ng-container>
</ng-template>
<ng-template #unmappedTitle>
  <li class="formErrorGroup">{{ "Forms.unmappedErrorGroup" | translate }}
  </li>
</ng-template>